<template>
  <div class="news">
    <div class="container path">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab container">
      <el-container>
        <el-aside width="170px">
          <el-card>
          <ul class="tab-type">
            <li>
              <router-link
                to="/aboutUs"
                :class="['nav-link', {'active': $route.path === '/aboutUs'}]"
              >关于我们</router-link>
            </li>
            <li>
              <router-link
                to="/aboutCourse"
                :class="['nav-link', {'active': $route.path === '/aboutCourse'}]"
              >关于课程</router-link>
            </li>
            <li>
              <router-link
                to="/newUser"
                :class="['nav-link', {'active': $route.path === '/newUser'}]"
              >新手指南</router-link>
            </li>
            <li>
              <router-link
                to="/howBuy"
                :class="['nav-link', {'active': $route.path === '/howBuy'}]"
              >如何购买</router-link>
            </li>
              <li>
              <router-link
                to="/downFile"
                :class="['nav-link', {'active': $route.path === '/downFile'}]"
              >班级课程如何报名</router-link>
            </li>
              <li>
              <router-link
                to="/phoneLook"
                :class="['nav-link', {'active': $route.path === '/phoneLook'}]"
              >手机如何看课程</router-link>
            </li>
          </ul>
          </el-card>
        </el-aside>
        <el-container>
          <router-view></router-view>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "news",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.carousel {
  height: 450px;
  position: relative;
  .carousel-box,
  /deep/ .el-carousel__container {
    height: 100%;
  }
}
.carousel-img {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.tab {
  overflow: hidden;
  padding-bottom: 40px;
}
.tab-type {
  
}
.tab-type li {
  width: 131px;
  cursor: pointer;
  height: 54px;
  line-height: 54px;
  text-align: center;
  margin: 0 auto;
  border-radius: 15px;
  margin-bottom: 15px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}
.tab-type li:last-child {
  margin-bottom: 0px;
}
.tab-cont {
  float: right;
  width: 975px;
}
.active {
  background-color: rgba(51, 119, 255, 0.2);
  color: rgba(51, 119, 255, 1) !important;
}
.path {
  color: rgba(166, 166, 166, 1);
  font-size: 16px;
  margin: 30px auto;
  overflow: hidden;
  a {
    display: block;
    line-height: 24px;
    height: 24px;
    float: left;
  }
  .path-to:hover {
    color: #0081e6;
  }
}
.go-icon {
  width: 24px;
  height: 24px;
}
.nav-link {
  display: block;
  text-decoration: none;
  border-radius: 15px;
  color: rgba(0, 0, 0, 1);
}
</style>